import tinycolor from 'tinycolor2';
import { Colors } from '@brg/ui';
import { DefaultTheme } from 'styled-components';
import { ApplicationTheme } from "../themes";
import { AppTester } from 'supporting';

enum BRS_VALUES {
  white = 255,
  lessWhite = 215,
  normal = 110,
  dark = 60
}

interface IOpt {
  hasCreators?: boolean,
  isCompetition?: boolean,
  isEdit?: boolean
}

export const createThemeByColor = (color: string, source: DefaultTheme, opt?: IOpt) => {
  const visibleTextColor = tinycolor.mostReadable(color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
  const isDarkText = visibleTextColor === Colors.galBlack100;
  const isCGRave = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isAKI = AppTester.isAKI();

  const { hasCreators, isEdit, isCompetition } = opt || {}
  const isZelandTheme = AppTester.isZelandTheme();

  if (isZelandTheme) {
    return {
      theme: ApplicationTheme.jhonata,
      isDarkText: false,
    };
  }
  
  const getCalcTheme = () => {
    const brs = tinycolor(color).getBrightness();

    if (isAKI && !isCompetition) {
      return ApplicationTheme.blue;
    }

    if (!isEdit) {
      return isDarkText ? ApplicationTheme.white : ApplicationTheme.grey
    }

    if (isGeo && !isGeoDafes) return ApplicationTheme.grey;
    else if (brs >= BRS_VALUES.lessWhite) return ApplicationTheme.white;
    else if (brs >= BRS_VALUES.normal) return ApplicationTheme.additionalWhite_1;
    else if (brs > BRS_VALUES.dark) return ApplicationTheme.additionalWhite_2;
    return ApplicationTheme.black;
  }

  const baseTheme = getCalcTheme();

  const finalTheme = /*isGameDeziiign
  ? {
      ...baseTheme,
      navigationBar: { ...source.navigationBar },
      isDarkText,
    }
  : */{
      ...baseTheme,
      navigationBar: { ...source.navigationBar },
      isDarkText,
      ...(source.themeName === 'greenawardTheme'
        ? {
            themeName: source.themeName,
            mainDropdownStyles: source.mainDropdownStyles,
          }
        : {}),
  };

  const isBlackBG = source.app.backgroundColor === '#000000';
  const isForceBlackBG = isBlackBG && !isCGRave && !AppTester.isJhonataNet() && !hasCreators;

  if (isForceBlackBG) {
    return {
      theme: ApplicationTheme.black,
      isDarkText: false,
    };
  }

  return {
    theme: finalTheme,
    isDarkText,
  };
};
import tinycolor from 'tinycolor2';
import { Colors } from '@brg/ui';
import { DefaultTheme } from 'styled-components';
import { ApplicationTheme } from "../themes";
import { AppTester } from 'supporting';

enum BRS_VALUES {
  white = 255,
  lessWhite = 215,
  normal = 110,
  dark = 60
}

interface IOpt {
  hasCreators?: boolean,
  isCompetition?: boolean,
  isEdit?: boolean
}

export const createThemeByColor = (color: string, source: DefaultTheme, opt?: IOpt) => {
  const visibleTextColor = tinycolor.mostReadable(color, [Colors.geoWhite100, Colors.galBlack100]).toHexString();
  const isDarkText = visibleTextColor === Colors.galBlack100;
  const isCGRave = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee();
  const isGeoDafes = AppTester.isGeoDafes();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const isAKI = AppTester.isAKI();

  const { hasCreators, isEdit, isCompetition } = opt || {}
  const isZelandTheme = AppTester.isZelandTheme();

  if (isZelandTheme) {
    return {
      theme: ApplicationTheme.jhonata,
      isDarkText: false,
    };
  }
  
  const getCalcTheme = () => {
    const brs = tinycolor(color).getBrightness();

    if (isAKI && !isCompetition) {
      return ApplicationTheme.blue;
    }

    if (!isEdit) {
      return isDarkText ? ApplicationTheme.white : ApplicationTheme.grey
    }

    if (isGeo && !isGeoDafes) return ApplicationTheme.grey;
    else if (brs >= BRS_VALUES.lessWhite) return ApplicationTheme.white;
    else if (brs >= BRS_VALUES.normal) return ApplicationTheme.additionalWhite_1;
    else if (brs > BRS_VALUES.dark) return ApplicationTheme.additionalWhite_2;
    return ApplicationTheme.black;
  }

  const baseTheme = getCalcTheme();

  const finalTheme = /*isGameDeziiign
  ? {
      ...baseTheme,
      navigationBar: { ...source.navigationBar },
      isDarkText,
    }
  : */{
      ...baseTheme,
      navigationBar: { ...source.navigationBar },
      isDarkText,
      ...(source.themeName === 'greenawardTheme'
        ? {
            themeName: source.themeName,
            mainDropdownStyles: source.mainDropdownStyles,
          }
        : {}),
  };

  const isBlackBG = source.app.backgroundColor === '#000000';
  const isForceBlackBG = isBlackBG && !isCGRave && !AppTester.isJhonataNet() && !hasCreators;

  if (isForceBlackBG) {
    return {
      theme: ApplicationTheme.black,
      isDarkText: false,
    };
  }

  return {
    theme: finalTheme,
    isDarkText,
  };
};
